import apiFetch from "@/utils/token-guard/apiFetch";

export interface FlightSearchParams {
  preferences: {
    currency: string;
    lang: string;
  };
  trip: string;
  segments: Array<{
    from: string;
    to: string;
  }>;
  departure_date: string;
  return_date?: string;
  travelClass: string;
  passengers: {
    adults: number;
    children: number;
    infants: number;
  };
}

export async function searchFlights(params: FlightSearchParams) {
  try {
    const response = await apiFetch('/api/flights/search/init', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    });


   return await response;
  } catch (error: any) {
    console.error(' Error:', error);
    throw error;
  }
}
